import { Paginator } from "primereact/paginator";

export default function PaginationControl({
  page,
  totalPages,
  totalData,
  perPage,
  onPrev,
  onNext,
  onGoToPage,
  onChangeRows, 
}) {
  const first = (page - 1) * perPage;

  return (
    <div className="vendor-paginator d-flex justify-content-center mt-3">
      <Paginator
        first={first}
        rows={perPage}
        totalRecords={totalData}
        rowsPerPageOptions={[50, 100, 500, 1000]}
        template="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        currentPageReportTemplate={`Showing ${first + 1} to ${Math.min(
          first + perPage,
          totalData
        )} of ${totalData} Leads`}
        onPageChange={(e) => {
          if (e.rows !== perPage) {
            onChangeRows(e.rows);
            return;
          }
          const targetPage = e.page + 1;

          if (targetPage === page) return;
          if (targetPage === page - 1) return onPrev();
          if (targetPage === page + 1) return onNext();

          onGoToPage?.(targetPage);
        }}
        className="p-paginator-sm"
      />
    </div>
  );
}
